import { render, staticRenderFns } from "./produtos.vue?vue&type=template&id=cc952f54"
import script from "./produtos.ts?vue&type=script&lang=js&external"
export * from "./produtos.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc952f54')) {
      api.createRecord('cc952f54', component.options)
    } else {
      api.reload('cc952f54', component.options)
    }
    module.hot.accept("./produtos.vue?vue&type=template&id=cc952f54", function () {
      api.rerender('cc952f54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/importacaonfe/produtos.vue"
export default component.exports